export default "__VITE_ASSET__CwpqJ5Rd__"